module.exports = __webpack_public_path__ + "img/bubble_hinter_objekt.svg";